import { observer } from '@rehaje/reactive-react'
import { createElement } from 'react'

import type { ElementNode } from './TypedNode'
import type { ElementModel } from './ViewModel'
import type { ViewComponent } from '@rehaje/react'
import type { FC } from 'react'

export const createElementComponent = (
  Component?: FC
): ViewComponent<ElementNode, ElementModel> =>
  observer(({ model, node }) => {
    if (!Component || model?.hidden === true) return null
    return createElement(
      Component,
      model?.getComponentProps() as any,
      node.children.map((child) => child.render())
    )
  })
